
(() => {
  const selector =
    "#inlineBYOBProducts .inline-byob-products-grid";

  const botany = [
    "Aromatherapy in a Cup",
    "Belly Happy",
    "Bullseye",
    "Bundle of Joy",
    "Calming Spirit",
    "Celestial Eyes",
    "Ethereal Beauty",
    "Miracle Day",
    "Morning Comfort",
    "Mother's Nectar",
    "Rhythmic Moon",
    "Smooth Relief",
    "Wanderlust",
    "Wonderfull"
  ];

  const clean = text => String(text || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

  const botanyNames = botany.map(clean);
  let active = "all";

  const style = document.createElement("style");

  style.textContent = `
    .treasures-tabs {
      display: flex;
      gap: 8px;
      margin: 12px 0 20px;
      width: 100%;
    }

    .treasures-tabs button {
      flex: 1;
      padding: 12px 6px;
      border: 1px solid #D3D9CB;
      border-radius: 5px;
      background: white;
      color: #5E6B47;
      font: inherit;
      font-size: 13px;
      cursor: pointer;
    }

    .treasures-tabs button.active {
      background: #5E6B47;
      border-color: #5E6B47;
      color: white;
    }

    #inlineBYOBProducts
    .inline-byob-product-card.treasures-hidden {
      display: none !important;
    }
  `;

  document.head.appendChild(style);

  function update() {
    document.querySelectorAll(selector).forEach(grid => {
      let tabs = grid.previousElementSibling;

      if (!tabs?.classList.contains("treasures-tabs")) {
        tabs = document.createElement("div");
        tabs.className = "treasures-tabs";

        tabs.innerHTML = `
          <button type="button" data-filter="all">
            View All
          </button>
          <button type="button" data-filter="botany">
            Botany
          </button>
          <button type="button" data-filter="artisan">
            Artisan
          </button>
        `;

        grid.before(tabs);

        tabs.addEventListener("click", event => {
          const button = event.target.closest(
            "button[data-filter]"
          );

          if (!button) return;

          active = button.dataset.filter;
          update();
        });
      }

      tabs.querySelectorAll("button").forEach(button => {
        const selected = button.dataset.filter === active;
        button.classList.toggle("active", selected);
        button.setAttribute("aria-pressed", String(selected));
      });

      grid.querySelectorAll(
        ":scope > .inline-byob-product-card"
      ).forEach(card => {
        const image = card.querySelector(
          ".product-image img"
        );

        const details = card.querySelector(
          ".product-details"
        );

        const name = clean(
          image?.alt || details?.textContent
        );

        const isBotany = botanyNames.some(
          tea => name.startsWith(tea)
        );

        const visible =
          active === "all" ||
          (active === "botany" && isBotany) ||
          (active === "artisan" && !isBotany);

        card.classList.toggle(
          "treasures-hidden",
          !visible
        );
      });
    });
  }

  let scheduled = false;

  const observer = new MutationObserver(() => {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  update();
})();
